<tcc-mono-dialog-layout
  [title]="'Route van ' + dierDisplayId"
  [displayBottomButtons]="false"
>
  <div class="route-map-content">
    <div *ngIf="loading" class="loading-panel ion-text-center">
      <ion-spinner></ion-spinner>
      <p>Verblijfplaatsen ophalen bij RVO...</p>
    </div>

    <div *ngIf="error && !hasValidStops()" class="error-box">{{ error }}</div>

    <div [class.hidden]="loading || (!!error && !hasValidStops())">
      <div *ngIf="error" class="warning-box">{{ error }}</div>

      <div class="route-layout">
        <div class="route-stops">
          <button
            *ngFor="let stop of resolvedStops"
            type="button"
            class="route-stop"
            [ngClass]="stopCardClass(stop)"
            (click)="focusStop(stop)"
          >
            <span class="route-stop__badge" [style.background]="stopColor(stop)">
              {{ stop.stopIndex + 1 }}
            </span>
            <div class="route-stop__body">
              <p class="route-stop__name">{{ stop.naam ?? 'Onbekende locatie' }}</p>
              <p class="route-stop__ubn">{{ stop.ubn || '—' }}</p>
              <p *ngIf="stop.typeLabel && stop.typeLabel !== '—'" class="route-stop__type">{{ stop.typeLabel }}</p>
              <p *ngIf="stop.address" class="route-stop__address">{{ stop.address }}</p>
              <div class="route-stop__dates">
                <p><span class="route-stop__arrow route-stop__arrow--in">▶</span> {{ stop.aanvoerLabel }}</p>
                <p [class.route-stop__present]="stop.isStillPresent">
                  <span>◀</span> {{ stop.afvoerLabel }}
                </p>
              </div>
              <p *ngIf="stop.lat === null" class="route-stop__missing">Geen coördinaten</p>
            </div>
          </button>
        </div>

        <div class="route-map-panel">
          <div class="route-legend">
            <span><i class="legend-dot legend-dot--first"></i> Eerste</span>
            <span><i class="legend-dot legend-dot--middle"></i> Tussenin</span>
            <span><i class="legend-dot legend-dot--last"></i> Laatste</span>
            <span *ngIf="skippedCount > 0" class="legend-skipped">{{ skippedCount }} zonder coördinaten</span>
          </div>
          <div class="map-frame">
            <div #mapContainer class="map-panel"></div>
          </div>
          <div class="map-footer">
            <span>© OpenStreetMap-bijdragers · Scrollen om in te zoomen</span>
            <span>Klik op een stop of marker voor details</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</tcc-mono-dialog-layout>
